// client/src/utils/formatters.js
export function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

export function formatPrice(amount) {
  return `$${parseFloat(amount).toFixed(2)}`;
}

export function truncate(str, maxLen = 100) {
  if (!str || str.length <= maxLen) return str;
  return str.slice(0, maxLen) + '...';
}

/**
 * Get user type display name.
 * Now reads from user.typename (from DB) with a static fallback.
 */
export function getUserTypeName(userOrType) {
  // If passed a user object with typename
  if (userOrType && typeof userOrType === 'object' && userOrType.typename) {
    return userOrType.typename;
  }
  // Fallback for raw integer (backward compat)
  const fallback = { 1: 'Free', 2: 'Stardust', 3: 'Evergreen', 4: 'Business Wizard' };
  return fallback[userOrType] || 'Unknown';
}

export function getStatusColor(status) {
  const colors = {
    draft: 'bg-gray-500',
    scheduled: 'bg-blue-500',
    sent: 'bg-green-500',
    expired: 'bg-red-500',
    active: 'bg-green-500',
    canceled: 'bg-red-500',
    past_due: 'bg-yellow-500',
  };
  return colors[status] || 'bg-gray-500';
}